<template>
  <div class="container">
    <nav-box title="设置" :back="true"></nav-box>
    <div class="content flex-column">
      <van-form @submit="onSubmit">
        <!-- 是否显示开牌 -->
        <van-field
          name="showCard"
          label="是否显示开牌"
          placeholder="请选择"
          readonly
          is-link
          @click="showCardPicker = true"
          :value="showCardText"
        />
        <van-popup v-model="showCardPicker" position="bottom">
          <van-picker
            :columns="showCardOptions"
            show-toolbar
            @confirm="onShowCardConfirm"
            @cancel="showCardPicker = false"
          />
        </van-popup>

        <!-- 是否显示客人类型 -->
        <van-field
          name="showGuestType"
          label="是否显示客人类型"
          placeholder="请选择"
          readonly
          is-link
          @click="showGuestTypePicker = true"
          :value="showGuestTypeText"
        />
        <van-popup v-model="showGuestTypePicker" position="bottom">
          <van-picker
            :columns="showGuestTypeOptions"
            show-toolbar
            @confirm="onShowGuestTypeConfirm"
            @cancel="showGuestTypePicker = false"
          />
        </van-popup>

        <!-- 可选择客人类型（多选） -->
        <van-field
          v-model="selectableGuestTypeText"
          name="selectableGuestType"
          label="可选择客人类型"
          placeholder="请选择"
          readonly
          is-link
          @click="openSelectableGuestTypePicker"
          required
          :error-message="errors.selectableGuestType"
        />
        <van-popup v-model="selectableGuestTypePicker" position="bottom" :style="{ height: '50%' }">
          <div class="multi-select-popup">
            <div class="popup-header">
              <span class="cancel-btn" @click="selectableGuestTypePicker = false">取消</span>
              <span class="title">选择客人类型</span>
              <span class="confirm-btn" @click="onSelectableGuestTypeConfirm">确定</span>
            </div>
            <div class="popup-content">
              <van-checkbox-group v-model="tempSelectableGuestType">
                <van-cell-group>
                  <van-cell
                    v-for="item in guestTypeOptions"
                    :key="item.id"
                    :title="item.name"
                    clickable
                    @click="toggleSelectableGuestType(item)"
                  >
                    <template #right-icon>
                      <van-checkbox :name="item.id" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
          </div>
        </van-popup>

        <!-- 默认客人类型（单选） -->
        <van-field
          name="defaultGuestType"
          label="默认客人类型"
          placeholder="请选择"
          readonly
          is-link
          @click="defaultGuestTypePicker = true"
          :value="defaultGuestTypeText"
          :error-message="errors.defaultGuestType"
        />
        <van-popup v-model="defaultGuestTypePicker" position="bottom">
          <van-picker
            :columns="guestTypeOptions"
            value-key="name"
            show-toolbar
            @confirm="onDefaultGuestTypeConfirm"
            @cancel="onDefaultGuestTypeCancel"
          />
        </van-popup>

        <!-- 券核销 -->
        <van-field
          name="isUseCoupon"
          label="券核销"
          placeholder="请选择"
          readonly
          is-link
          @click="showUseCouponPicker = true"
          :value="showUseCouponText"
        />
        <van-popup v-model="showUseCouponPicker" position="bottom">
          <van-picker
            :columns="useCoupoOptions"
            show-toolbar
            @confirm="onShowUseCoupon"
            @cancel="showUseCouponPicker = false"
          />
        </van-popup>

        <!-- 付款方式（多选） -->
        <van-field
          v-model="selectablePaymentText"
          name="selectablePayment"
          label="付款方式"
          placeholder="请选择"
          readonly
          is-link
          @click="openSelectablePaymentPicker"
        />
        <van-popup v-model="selectablePaymentPicker" position="bottom" :style="{ height: '50%' }">
          <div class="multi-select-popup">
            <div class="popup-header">
              <span class="cancel-btn" @click="selectablePaymentPicker = false">取消</span>
              <span class="title">选择付款方式</span>
              <span class="confirm-btn" @click="onSelectablePaymentConfirm">确定</span>
            </div>
            <div class="popup-content">
              <van-checkbox-group v-model="tempSelectablePayment">
                <van-cell-group>
                  <van-cell
                    v-for="item in paymentOptions"
                    :key="item.value"
                    :title="item.label"
                    clickable
                    @click="toggleSelectablePayment(item)"
                  >
                    <template #right-icon>
                      <van-checkbox :name="item.value" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
          </div>
        </van-popup>

        <div class="form-buttons">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import navBox from "@/components/nav-box.vue";
export default {
  components: {
    navBox,
  },
  name: "settings",
  data() {
    return {
      formData: {
        showCard: true,
        showGuestType: true,
        selectableGuestType: [],
        defaultGuestType: null,
        isUseCoupon:false,
        selectablePayment: [],
      },
      guestTypeOptions: [
      ],
      showCardOptions: [
        { text: '显示', value: true },
        { text: '不显示', value: false },
      ],
      showGuestTypeOptions: [
        { text: '显示', value: true },
        { text: '不显示', value: false },
      ],
      useCoupoOptions: [
        { text: '开启', value: true },
        { text: '关闭', value: false },
      ],
      showCardPicker: false,
      showGuestTypePicker: false,
      selectableGuestTypePicker: false,
      defaultGuestTypePicker: false,
      showUseCouponPicker:false,
      selectablePaymentPicker: false,
      tempSelectableGuestType: [],
      tempSelectablePayment: [],
      errors: {
        selectableGuestType: '',
        defaultGuestType: '',
      },

      // 付款方式
      paymentOptions:[
        {
          label:'会员',
          value:'01',
        },
        {
          label:'我用券',
          value:'02',
        },
        {
          label:'微信/支付宝',
          value:'03',
        },
      ]
    };
  },
  computed: {
    showCardText() {
      return this.formData.showCard ? '显示' : '不显示';
    },
    showGuestTypeText() {
      return this.formData.showGuestType ? '显示' : '不显示';
    },
    showUseCouponText() {
      return this.formData.isUseCoupon ? '开启' : '关闭';
    },
    selectableGuestTypeText() {
      if (this.formData.selectableGuestType.length === 0) return '';
      return this.formData.selectableGuestType.map(item => item.name).join('、');
    },
    selectablePaymentText() {
      if (this.formData.selectablePayment.length === 0) return '';
      return this.formData.selectablePayment.map(item => item.label).join('、');
    },
    defaultGuestTypeText() {
      const { defaultGuestType } = this.formData
      const item = this.guestTypeOptions.find(item=>item.id==defaultGuestType)
      return item && item.name;
    },
  },
  methods: {
    onShowCardConfirm(e) {
      this.formData.showCard = e.value;
      this.showCardPicker = false;
    },
    onShowGuestTypeConfirm(e) {
      this.formData.showGuestType = e.value;
      this.showGuestTypePicker = false;
      if (!this.formData.showGuestType) {
        this.errors.defaultGuestType = '';
      }
    },
    onShowUseCoupon(e){
      this.formData.isUseCoupon = e.value;
      this.showUseCouponPicker = false;
      console.log(this.formData)
    },
    onDefaultGuestTypeConfirm(e) {
      console.log(e)
      this.formData.defaultGuestType = e.id;
      this.defaultGuestTypePicker = false;
      this.validateDefaultGuestType();
    },
    onDefaultGuestTypeCancel(){
      this.defaultGuestTypePicker=false
      this.formData.defaultGuestType = ''
    },

    // 多选逻辑（不变）
    openSelectableGuestTypePicker() {
      this.tempSelectableGuestType = this.formData.selectableGuestType.map(item => item.id);
      this.selectableGuestTypePicker = true;
    },
    toggleSelectableGuestType(option) {
      const idx = this.tempSelectableGuestType.indexOf(option.id);
      if (idx > -1) {
        this.tempSelectableGuestType.splice(idx, 1);
      } else {
        this.tempSelectableGuestType.push(option.id);
      }
    },
    onSelectableGuestTypeConfirm() {
      this.formData.selectableGuestType = this.guestTypeOptions.filter(item =>
        this.tempSelectableGuestType.includes(item.id)
      );
      this.selectableGuestTypePicker = false;
      this.validateSelectableGuestType();
    },

    // 付款方式多选逻辑
    openSelectablePaymentPicker() {
      this.tempSelectablePayment = this.formData.selectablePayment.map(item => item.value);
      this.selectablePaymentPicker = true;
    },
    toggleSelectablePayment(option) {
      const idx = this.tempSelectablePayment.indexOf(option.value);
      if (idx > -1) {
        this.tempSelectablePayment.splice(idx, 1);
      } else {
        this.tempSelectablePayment.push(option.value);
      }
    },
    onSelectablePaymentConfirm() {
      this.formData.selectablePayment = this.paymentOptions.filter(item =>
        this.tempSelectablePayment.includes(item.value)
      );
      this.selectablePaymentPicker = false;
    },

    // 校验
    validateSelectableGuestType() {
      if (this.formData.selectableGuestType.length === 0) {
        this.errors.selectableGuestType = '请至少选择一个客人类型';
        return false;
      }
      this.errors.selectableGuestType = '';
      return true;
    },
    validateDefaultGuestType() {
      if (!this.formData.showGuestType && !this.formData.defaultGuestType) {
        this.errors.defaultGuestType = '不显示客人类型，必须选择默认客人类型';
        return false;
      }
      this.errors.defaultGuestType = '';
      return true;
    },
    // 获取客人类型列表
    getGuestType() {
      this.$fetchNo(this.Api.GuestType, { status: 1 }).then((res) => {
        const guestTypeList = []
        res.data.items.forEach(item=>{
          if(item.terminals && item.terminals.find(e=>e.terminalId==9)){
            guestTypeList.push(item)
          }
        })
        this.guestTypeOptions = guestTypeList 
      });
    },
    onSubmit() {
      this.errors = { selectableGuestType: '', defaultGuestType: '' };
      const valid1 = this.validateSelectableGuestType();
      const valid2 = this.validateDefaultGuestType();
      if (!valid1 || !valid2) {
        this.$toast('请完善表单信息');
        return;
      }

      if(this.formData.selectableGuestType.length==1){
        this.formData.defaultGuestType = this.formData.selectableGuestType[0].id
      }

      // 调用接口保存到后端
      const data = {
        moduleName: "selfservice",
        settings: JSON.stringify(this.formData)
      };
      this.$post(this.Api.setUserPreference, data).then((res) => {
        console.log('保存成功:', res);
        this.$toast.success('保存成功');
        this.$router.push("/prepayment");
      }).catch((err) => {
        console.error('保存失败:', err);
        this.$toast.fail('保存失败');
      });
    },
  },
  mounted() {
    // 调用接口获取设置数据
    this.$fetchNo(this.Api.getUserPreference, {moduleName:'selfservice'}, 'get').then((res) => {
      if (res.data && res.data.length>0) {
        console.log('获取设置数据:', res.data);
        const data = JSON.parse(res.data)
        Object.assign(this.formData, data);
      }
    }).catch((err) => {
      console.error('获取设置失败:', err);
    });

    this.getGuestType()
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #f7f8fa;
  min-height: 100vh;
}
.content {
  padding: 16px 0;
}
.form-buttons {
  margin-top: 24px;
  padding: 0 16px;
}
:deep(.van-field__label) {
  width: 160px;
}
:deep(.van-field__value) {
  text-align: right;
}
.multi-select-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 1px solid #ebedf0;
  font-size: 38px;
}
.popup-header .cancel-btn,
.popup-header .confirm-btn {
  color: #1989fa;
  cursor: pointer;
}
.popup-header .title {
  font-weight: 500;
}
.popup-content {
  flex: 1;
  overflow-y: auto;
}

/deep/ .van-field__label{
  font-size: 16px;
}

/deep/ .van-field__control{
  font-size: 16px;
}
</style>